import script from "./Foots.vue?vue&type=script&setup=true&lang=js"
export * from "./Foots.vue?vue&type=script&setup=true&lang=js"

import "./Foots.vue?vue&type=style&index=0&id=23063c38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23063c38"]])

export default __exports__